import loginDialog from '@/components/common/login/login'
import { permissionList } from '@/dictionary/index'
import Layout from '@/layout/Layout'
import store from '@/store/index'
import { storage } from "@/utils/hooks/index"
import jwtDecode from 'jwt-decode'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/realtime',
    children: [
      {
        path: '/realtime',
        name: 'Home',
        meta: { title: "实时数据", tag: 'realtime' },
        component: resolve => require(['@/views/home/Index'], resolve),
        component: () => import(/* webpackChunkName: "Home" */'@/views/home/Index'),
        // beforeEnter: function () {
        //   return
        // },
      },
      {
        path: "/real-time-network-distribution",
        name: "RealTimeNetworkDistribution",
        meta: { title: '实时数据网速分布', tag: 'realtime', isChildren: true },
        component: () => import('@/components/realTimeData/children/RealTimeNetworkDistribution.vue')
      },
      {
        path: "/real-time-user-speed",
        name: "RealTimeUserSpeed",
        meta: { title: '实时数据用户网速排行', tag: 'realtime', isChildren: true },
        component: () => import('@/components/realTimeData/children/RealTimeUserSpeed.vue')
      },
      {
        path: "/real-time-month-score",
        name: "RealTimeMonthScore",
        meta: { title: '实时数据近三十天网速趋势', tag: 'realtime', isChildren: true },
        component: () => import('@/components/realTimeData/children/RealTimeMonthScore.vue')
      },
      {
        path: "/real-time-network-quality-comparison",
        name: "RealTimeNetworkQualityComparison",
        meta: { title: '实时数据网络质量对比', tag: 'realtime', isChildren: true },
        component: () => import('@/components/realTimeData/children/RealTimeNetworkQualityComparison.vue')
      },
      {
        path: "/real-time-special-experience-test",
        name: "RealTimeSpecialExperienceTest",
        meta: { title: '实时数据专项体验测速', tag: 'realtime', isChildren: true },
        component: () => import('@/components/realTimeData/children/RealTimeSpecialExperienceTest.vue')
      },
      {
        path: "/real-time-network-speed-ratio",
        name: "RealTimeNetworkSpeedRatio",
        meta: { title: '实时数据网速占比', tag: 'realtime', isChildren: true },
        component: () => import('@/components/realTimeData/children/RealTimeNetworkSpeedRatio.vue')
      },
      {
        path: "/real-time-province-speed",
        name: "RealTimeProvinceSpeed",
        meta: { title: '实时数据各省网速中值', tag: 'realtime', isChildren: true },
        component: () => import('@/components/realTimeData/children/RealTimeProvinceSpeed.vue')
      },
      /* 排行榜路由开始 */
      {
        path: "ranks",
        name: 'RankingData',
        meta: { title: "排行榜", },
        component: resolve => require(['@/views/rankingData/Index'], resolve),
      },
      { path: '/ranks-data', redirect: '/ranks' },
      {
        path: "/ranks-phone-brandSpeed",
        name: "RanksPhoneBrandSpeed",
        meta: { title: '排行榜5G手机网速中值排行', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksPhoneBrandSpeed.vue')
      },
      {
        path: "/ranks-phone-brand-recommendation",
        name: "RanksPhoneBrandRecommendation",
        meta: { title: '排行榜5G手机品牌推荐排行', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksPhoneBrandRecommendation.vue')
      },
      {
        path: "/ranks-router-high-opinion",
        name: "RanksRouterHighOpinion",
        meta: { title: '排行榜5G手机品牌推荐排行', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksRouterHighOpinion.vue')
      },
      {
        path: "/ranks-router-market",
        name: "RanksRouterMarket",
        meta: { title: '排行榜路由器市场占有率', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksRouterMarket.vue')
      },
      {
        path: "/ranks-phone-market",
        name: "RanksPhoneMarket",
        meta: { title: '排行榜路由器安卓5G手机市场占有率', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksPhoneMarket.vue')
      },
      {
        path: "/ranks-platform-network-delay",
        name: "RanksPlatformNetworkDelay",
        meta: { title: '排行榜主流平台时延排行', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksPlatformNetworkDelay.vue')
      },
      {
        path: "/ranks-websites-entry-speed",
        name: "RanksWebsitesEntrySpeed",
        meta: { title: '排行榜主流网站打开速度', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksWebsitesEntrySpeed.vue')
      },
      {
        path: "/ranks-vidoe-buffer",
        name: "RanksVideoBuffer",
        meta: { title: '排行榜网络视频缓冲比', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksVideoBuffer.vue')
      },
      {
        path: "/ranks-province-network-quality",
        name: "RanksProvinceNetworkQuality",
        meta: { title: '排行榜各省网络质量排行', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksProvinceNetworkQuality.vue')
      },
      {
        path: "/ranks-video-loadding",
        name: "RanksVideoLoadding",
        meta: { title: '排行榜各省视频平均加载时间', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksVideoLoadding.vue')
      },
      {
        path: "/ranks-video-loadding",
        name: "RanksVideoLoadding",
        meta: { title: '排行榜各省视频平均加载时间', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksVideoLoadding.vue')
      },
      {
        path: "/ranks-video-resolution-ratio",
        name: "RanksVideoResolutionRatio",
        meta: { title: '排行榜各省视频平均加载时间', isChildren: true },
        component: () => import('@/components/rankingData/children/RanksVideoResolutionRatio.vue')
      },
      /* 排行榜路由结束 */
      {
        path: "map",
        name: 'mapData',
        meta: { title: "地图", tag: 'map' },
        redirect: '/map/speed',
        component: resolve => require(['@/views/mapData/Index'], resolve),
        children: [
          {
            path: "speed",
            name: "speedMap",
            meta: { title: '网速地图', tag: 'speedMap' },
            component: () => import(/* webpackChunkName: "speedMap" */'@/views/mapData/NationalMap.vue')
          },
          {
            path: "signal",
            name: "hotMap",
            meta: { title: '信号热力图', tag: 'hotMap' },
            component: () => import(/* webpackChunkName: "speedMap" */'@/views/mapData/HotMap.vue')
          },
        ],
        // beforeEnter: function (){
        //   return ;
        // },
      },
      /* 找回密码 */
      {
        path: "/back-password",
        name: "BackPassword",
        meta: { title: '找回密码' },
        component: () => import('@/views/backPassword/index.vue')
      },
      /* 个人中心 */
      {
        path: "/personal-center",
        name: "PersonalCenter",
        meta: { title: '个人中心' },
        component: () => import('@/views/personalCenter/index.vue')
      },
      {
        path: "/account-cancel",
        name: "AccountCancel",
        meta: { title: '注销账号' },
        component: () => import('@/components/personalCenter/cancel/AccountCancel.vue')
      },
      /* 会员购买页面 */
      {
        path: "/pay-member",
        name: "Member",
        meta: { title: '会员购买' },
        component: () => import('@/views/member/index.vue')
      }
    ]
  },

]

// 每次初始化路由时都从本地读下token 否则刷新登录状态失效
if (storage.get("access_token") && storage.get("token_type")) {
  store.commit("login/setValue", [storage.get("access_token"), 'access_token'])
  store.commit("login/setValue", [storage.get("refresh_token"), 'refresh_token'])
  store.commit("login/setValue", [storage.get("token_type"), 'token_type'])
  store.commit("login/setValue", [storage.get("is_login"), 'is_login'])
  store.commit("login/setValue", [storage.get("is_member"), 'is_member'])
  store.commit("login/setValue", [storage.get("effect_end_date"), 'effect_end_date'])
  store.commit("login/setValue", [storage.get("userInfor"), 'userInfor'])
}

const router = new VueRouter({
  routes,
  mode: 'history'
})

//每次刷新要重新判断权限来增加路由
//router.onReady(() => {
if (store.getters['login/getIsLogin'] && storage.get("access_token") && storage.get("token_type")) {
  //已经登录了
  try {
    const infor = jwtDecode(store.getters['login/getToken'])
    if (infor.roles && infor.roles[1] && infor.roles[1].roleId === 2) {
      //说明了是可以看
      if (permissionList && permissionList.length) {
        permissionList.forEach(item => {
          router.addRoute('Layout', item)
        })
      }
    }
  } catch (error) {

  }
}
//})



/**
 * 在router/index.js中定义$addRoutes,调用这个方法来添加路由，这个方法会先重置路由
  这个路由只会包括非权限页，比如登录页，再调用router.addRoutes添加权限路由，
  此方法亲测，完美解决，方法来自GitHub的issues,https://github.com/vuejs/vue-router/issues/2886
  角色切换，addRoutes提示有重复的路由，无法删除之前角色的路由
  刷新页面，动态路由消失，提示404
  此处对运营商页面进行权限管理
 */
const constantRouterMap = [{
  path: '/',
  name: 'Layout',
  component: Layout,
  redirect: '/realtime',
  children: [
    {
      path: '/realtime',
      name: 'Home',
      meta: { title: "实时数据", tag: 'realtime' },
      component: resolve => require(['@/views/home/Index'], resolve),
      component: () => import(/* webpackChunkName: "Home" */'@/views/home/Index'),
      // beforeEnter: function () {
      //   return
      // },
    },
    {
      path: "/real-time-network-distribution",
      name: "RealTimeNetworkDistribution",
      meta: { title: '实时数据网速分布', tag: 'realtime', isChildren: true },
      component: () => import('@/components/realTimeData/children/RealTimeNetworkDistribution.vue')
    },
    {
      path: "/real-time-user-speed",
      name: "RealTimeUserSpeed",
      meta: { title: '实时数据用户网速排行', tag: 'realtime', isChildren: true },
      component: () => import('@/components/realTimeData/children/RealTimeUserSpeed.vue')
    },
    {
      path: "/real-time-month-score",
      name: "RealTimeMonthScore",
      meta: { title: '实时数据近三十天网速趋势', tag: 'realtime', isChildren: true },
      component: () => import('@/components/realTimeData/children/RealTimeMonthScore.vue')
    },
    {
      path: "/real-time-network-quality-comparison",
      name: "RealTimeNetworkQualityComparison",
      meta: { title: '实时数据网络质量对比', tag: 'realtime', isChildren: true },
      component: () => import('@/components/realTimeData/children/RealTimeNetworkQualityComparison.vue')
    },
    {
      path: "/real-time-special-experience-test",
      name: "RealTimeSpecialExperienceTest",
      meta: { title: '实时数据专项体验测速', tag: 'realtime', isChildren: true },
      component: () => import('@/components/realTimeData/children/RealTimeSpecialExperienceTest.vue')
    },
    {
      path: "/real-time-network-speed-ratio",
      name: "RealTimeNetworkSpeedRatio",
      meta: { title: '实时数据网速占比', tag: 'realtime', isChildren: true },
      component: () => import('@/components/realTimeData/children/RealTimeNetworkSpeedRatio.vue')
    },
    {
      path: "/real-time-province-speed",
      name: "RealTimeProvinceSpeed",
      meta: { title: '实时数据各省网速中值', tag: 'realtime', isChildren: true },
      component: () => import('@/components/realTimeData/children/RealTimeProvinceSpeed.vue')
    },
    /* 排行榜路由开始 */
    {
      path: "ranks",
      name: 'RankingData',
      meta: { title: "排行榜", },
      component: resolve => require(['@/views/rankingData/Index'], resolve),
    },
    { path: '/ranks-data', redirect: '/ranks' },
    {
      path: "/ranks-phone-brandSpeed",
      name: "RanksPhoneBrandSpeed",
      meta: { title: '排行榜5G手机网速中值排行', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksPhoneBrandSpeed.vue')
    },
    {
      path: "/ranks-phone-brand-recommendation",
      name: "RanksPhoneBrandRecommendation",
      meta: { title: '排行榜5G手机品牌推荐排行', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksPhoneBrandRecommendation.vue')
    },
    {
      path: "/ranks-router-high-opinion",
      name: "RanksRouterHighOpinion",
      meta: { title: '排行榜5G手机品牌推荐排行', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksRouterHighOpinion.vue')
    },
    {
      path: "/ranks-router-market",
      name: "RanksRouterMarket",
      meta: { title: '排行榜路由器市场占有率', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksRouterMarket.vue')
    },
    {
      path: "/ranks-phone-market",
      name: "RanksPhoneMarket",
      meta: { title: '排行榜路由器安卓5G手机市场占有率', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksPhoneMarket.vue')
    },
    {
      path: "/ranks-platform-network-delay",
      name: "RanksPlatformNetworkDelay",
      meta: { title: '排行榜主流平台时延排行', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksPlatformNetworkDelay.vue')
    },
    {
      path: "/ranks-websites-entry-speed",
      name: "RanksWebsitesEntrySpeed",
      meta: { title: '排行榜主流网站打开速度', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksWebsitesEntrySpeed.vue')
    },
    {
      path: "/ranks-vidoe-buffer",
      name: "RanksVideoBuffer",
      meta: { title: '排行榜网络视频缓冲比', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksVideoBuffer.vue')
    },
    {
      path: "/ranks-province-network-quality",
      name: "RanksProvinceNetworkQuality",
      meta: { title: '排行榜各省网络质量排行', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksProvinceNetworkQuality.vue')
    },
    {
      path: "/ranks-video-loadding",
      name: "RanksVideoLoadding",
      meta: { title: '排行榜各省视频平均加载时间', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksVideoLoadding.vue')
    },
    {
      path: "/ranks-video-loadding",
      name: "RanksVideoLoadding",
      meta: { title: '排行榜各省视频平均加载时间', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksVideoLoadding.vue')
    },
    {
      path: "/ranks-video-resolution-ratio",
      name: "RanksVideoResolutionRatio",
      meta: { title: '排行榜各省视频平均加载时间', isChildren: true },
      component: () => import('@/components/rankingData/children/RanksVideoResolutionRatio.vue')
    },
    /* 排行榜路由结束 */
    {
      path: "map",
      name: 'mapData',
      meta: { title: "地图", tag: 'map' },
      redirect: '/map/speed',
      component: resolve => require(['@/views/mapData/Index'], resolve),
      children: [
        {
          path: "speed",
          name: "speedMap",
          meta: { title: '网速地图', tag: 'speedMap' },
          component: () => import(/* webpackChunkName: "speedMap" */'@/views/mapData/NationalMap.vue')
        },
        {
          path: "signal",
          name: "hotMap",
          meta: { title: '信号热力图', tag: 'hotMap' },
          component: () => import(/* webpackChunkName: "speedMap" */'@/views/mapData/HotMap.vue')
        },
      ],
      // beforeEnter: function (){
      //   return ;
      // },
    },
    /* 找回密码 */
    {
      path: "/back-password",
      name: "BackPassword",
      meta: { title: '找回密码' },
      component: () => import('@/views/backPassword/index.vue')
    },
    /* 个人中心 */
    {
      path: "/personal-center",
      name: "PersonalCenter",
      meta: { title: '个人中心' },
      component: () => import('@/views/personalCenter/index.vue')
    },
    {
      path: "/account-cancel",
      name: "AccountCancel",
      meta: { title: '注销账号' },
      component: () => import('@/components/personalCenter/cancel/AccountCancel.vue')
    },
    /* 会员购买页面 */
    {
      path: "/pay-member",
      name: "Member",
      meta: { title: '会员购买' },
      component: () => import('@/views/member/index.vue')
    }
  ]
}] // 默认的路由规则，比如登录页（非权限页）
router.$addRoutes = (params) => {
  router.matcher = new VueRouter({ // 重置路由规则
    routes: constantRouterMap
  }).matcher
  router.addRoutes(params) // 添加路由
}



//路由白名单 不需要权限的页面直接可以进行跳转
const whiteList = ['/', '/realtime', '/operators', '/ranks', '/map/speed', '/map/signal', '/back-password']

router.beforeEach(async (to, from, next) => {
  //拦截运营商路由
  if (store.getters['login/getIsLogin'] && storage.get("access_token") && storage.get("token_type")) {
    //已经登录了
    try {
      const infor = jwtDecode(store.getters['login/getToken'])
      if (infor.roles && infor.roles[1] && infor.roles[1].roleId === 2) {
        next()
      } else {
        if (to.meta.tag === 'operator'||to.path.includes('operator')) {
          // next({
          //   path: '/'
          // })
          location.href = '/'
        }
      }
    } catch (error) {
      if (to.meta.tag === 'operator'||to.path.includes('operator')) {
        // next({
        //   path: '/'
        // })
        location.href = '/'
      }
    }
  } else {
    if (to.meta.tag === 'operator'|| to.path.includes('operator')) {
      // next({
      //   path: '/'
      // })
      location.href = '/'
    }
  }

  //百度统计
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }

  //白名单和登录拦截
  if (to.path == '/pay-member' && sessionStorage.getItem('memberLink')) {
    sessionStorage.removeItem('memberLink')
    router.push({ path: '/' })
  } else if (whiteList.indexOf(to.path) > -1) next()
  else if (store.getters['login/getIsLogin'] && store.getters['login/getTokenType'] && store.getters['login/getIsLogin'] && store.getters['login/getUserInfor']) next()
  else {
    store.commit("login/setValue", [to.path, 'backUrl'])
    loginDialog.open()
  }
  //next()
})

router.afterEach((to, from) => {
  //修改当前的全局导航名
  if (to.meta && from.meta && (to.meta.tag === from.meta.tag)) {

  } else {
    router.app.$store.dispatch('changeCity', '全国')
  }
  try {
    router.app.$store.dispatch("changeNavigation", to.name)
  } catch (error) {
    
  }
 
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router
